import { shallow } from 'zustand/shallow';
import { ChartTheme } from '@carbon/charts-react';
import { useAppStore } from 'src/states/app';

/**
 * The Carbon chart theme, derived from the app's light/dark setting. Every dashboard chart
 * component repeated this same selector + ternary; factored out so there is one place that
 * knows 'dark' maps to ChartTheme.G100 ('g100') and everything else maps to ChartTheme.G10
 * ('g10').
 */
export const useChartTheme = (): ChartTheme => {
  const { theme } = useAppStore((state) => ({ theme: state.theme }), shallow);
  return theme === 'dark' ? ChartTheme.G100 : ChartTheme.G10;
};
